@if (hasKeep) {
  <mat-checkbox
    id="{{fieldId}}"
    [checked]="keepObj.canKeep"
    (change)="toggleKeep()"
  ></mat-checkbox>
}
